import { action, makeObservable, observable } from 'mobx';
import type { IActivePhase, IPhaseInfo } from '@/engine/app/CasePhaseData/interfaces.ts';

export class ActivePhase implements IActivePhase {
  @observable
  public id = '';

  @observable
  public name = '';

  public constructor() {
    makeObservable(this);
  }

  @action
  public set(info: IPhaseInfo): void {
    this.id = info.id;
    this.name = info.name;
  }
}
